import React, { useEffect } from 'react'
import clss from 'classnames'
import dynamic from 'next/dynamic'
export interface Props {
  type: string
  className?: string
  onClick?: (e?: any) => void
  size?: number
  style?: React.CSSProperties
}

const Icon = (props: Props) => {
  const { type, className, size, onClick, style = {} } = props
  const s = size ? { width: size, height: size } : {}
  const styles = Object.assign(style, s)

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    dynamic(import('../../../assets/js/icon.min.js'), {
      ssr: false
    })
  }, [])

  return (
    <svg
      style={styles}
      className={clss(
        className,
        `wallet-font-${type}`,
        'wallet-font',
        'iconfont',
        {
          'cursor-pointer': !!onClick,
        },
      )}
      aria-hidden="true"
      onClick={e => onClick && onClick(e)}>
      <use xlinkHref={`#wallet-font-${type}`}></use>
    </svg>
  )
}

export default Icon
